export default (theme: any) => ({
    root: {
        flexGrow: 1,
    },

    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        borderRadius: '2px',
    },

    cardHeaderTitle: {
        [theme.breakpoints.up('sm')]: {
            paddingLeft: '50px',
        },
    },

    subCardHeaderTitle: {
        [theme.breakpoints.up('sm')]: {
            paddingLeft: '50px',
        },
    },
})
